import { useEffect } from 'react';
import { currentEmbeddedApp, postOpenPlans } from '@/lib/app-embed/readEmbeddedApp';

/** Store rules forbid web payment inside the mobile app. When a payment modal
 *  is opened there, send the user to the app's Planos tab and close it.
 *  Returns true while embedded, so the modal renders nothing. */
export function useEmbeddedPaymentBlock(open: boolean, onOpenChange: (open: boolean) => void): boolean {
  const embedded = currentEmbeddedApp() !== null;
  useEffect(() => {
    if (!embedded || !open) return;
    postOpenPlans();
    onOpenChange(false);
  }, [embedded, open, onOpenChange]);
  return embedded;
}
